import { render, staticRenderFns } from "./createCurrency.vue?vue&type=template&id=4d227066"
import script from "./createCurrency.vue?vue&type=script&lang=js"
export * from "./createCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports